export const PERFORMACE_TAB = 'performance';
export const OPTIMIZATION_TAB = 'optimization';
export const TEST_RESULTS_TAB = 'testResults';
export const SMART_CONTENT_TAB = 'smartContent';